const Message = {
    title: "",
    text: "",
    active: true
}

export default  Message;
